/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Pricing_UnknownInputs */

const en_agent_authorization_pricing_unknown = /** @type {(inputs: Agent_Authorization_Pricing_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not specified`)
};

const zh_agent_authorization_pricing_unknown = /** @type {(inputs: Agent_Authorization_Pricing_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未说明`)
};

/**
* | output |
* | --- |
* | "Not specified" |
*
* @param {Agent_Authorization_Pricing_UnknownInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_pricing_unknown = /** @type {((inputs?: Agent_Authorization_Pricing_UnknownInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Pricing_UnknownInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_pricing_unknown(inputs)
	return zh_agent_authorization_pricing_unknown(inputs)
});
export { agent_authorization_pricing_unknown as "agent.authorization.pricing.unknown" }